import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-tea-material",
  "use": "icon-soc-tea-material-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-tea-material\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<path d=\"M288 320h384c0 192-64 352-192 416-128-64-192-224-192-416z\" /><path d=\"M672 384h80c64 0 96 48 96 96s-32 96-96 96h-48\" /><path d=\"M416 192c32 48 32 96 0 144M512 160c32 48 32 96 0 144\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-tea-material.svg
// module id = iuD9
// module chunks = 546